import { Injectable, Inject, Renderer2, RendererFactory2, DOCUMENT } from '@angular/core';

import { SecurityService } from '../public-api';
import { PreferencesService } from './preferences/preferences.service';

@Injectable({
  providedIn: 'root'
})
export class WebbrokerResponsiveService {
  private renderer: Renderer2;

  constructor(@Inject(DOCUMENT) private document: Document,
              rendererFactory: RendererFactory2,
              private securityService: SecurityService,
              private preferencesService: PreferencesService) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  init(): void {
    const usingResponsive = this.preferencesService
      .getPreloadedUserPreference<boolean>('USING_RESPONSIVE') ?? true;
    this.setContentAttribute(usingResponsive);
    this.preferencesService.onResponsivePreferenceChange.subscribe(
      (result: boolean): void => this.setContentAttribute(result));
  }

  private setContentAttribute(usingResponsive: boolean): void {
    const responsiveEnabled = this.securityService.hasPermission('RESPONSIVE_VIEW')
      && usingResponsive;
    const metaElement = this.document.getElementById('td-wb-meta-viewport');
    if (responsiveEnabled) {
      this.renderer.setAttribute(metaElement, 'content', 'width=device-width, initial-scale=1.0');
    } else {
      this.renderer.setAttribute(metaElement, 'content', 'width=1024, initial-scale=1.0');
    }
  }
}
